import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResendMsg } from '../ResendMsg';

@Component({
  selector: 'app-resend-dialog',
  templateUrl: './resend-dialog.component.html',
  styleUrls: ['./resend-dialog.component.css']
})
export class ResendDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ResendDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResendMsg) { }

  ngOnInit(): void {
  }

  

  onNoClick(): void {
    this.dialogRef.close();
  }

}
  

